grecaptcha.ready(function () {
    function getToken(formId) {
        grecaptcha.execute(MyAjax.recaptcha_site_key, {action: 'submit'})
            .then(function (token) {
                var inputElement = document.getElementById(formId + '_recaptchaResponse');
                if (inputElement) {
                    inputElement.value = token;
                }
            })
            .catch(function () {});
    }

    // Get tokens for all forms (prefixes match contact-form.php args)
    getToken('oc-inv');     // offcanvas invest form
    getToken('oc-con');     // offcanvas contact form
    getToken('cf');         // page contact form
    getToken('newsletter'); // newsletter form

    // Refresh tokens every 2 minutes
    setInterval(function () {
        getToken('oc-inv');
        getToken('oc-con');
        getToken('cf');
        getToken('newsletter');
    }, 120000);
});
